<template>
  <div>
    <!-- <div
      v-if="gheibats.length > 0"
      class="fixedPosition"
      :style="[isMobile ? { width: '100%' } : { width: 'calc(100% - 300px)' }]"
    >
      <div class="divider dparent">
        <b> {{ gheibats[visibleGheibat].N_Cycle }}</b>
      </div>

      <div class="divider dchild">
        {{ gheibats[visibleGheibat].courses[visibleCourse].N_Title }}
      </div>
    </div> -->
    <div style="padding-bottom: 50px">
      <div v-for="(gheibat, index) in gheibats" :key="gheibat.srl_cycle">
        <div class="divider dparent">
          <b> {{ gheibat.N_Cycle }}</b>
        </div>
        <div
          v-for="(course, key) in gheibat.courses"
          :key="key"
          class="scrollHandler"
          :id="index + '_' + key"
        >
          <div class="divider dchild">
            {{ course.N_Title }}
          </div>

          <v-data-table
            :items="course.gheibats"
            :headers="courseHeaders"
            class="elevation-1"
            :disable-pagination="true"
            :hide-default-footer="true"
            :no-data-text="tableText"
            :header-props="headerProps"
          ></v-data-table>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getGheibat } from "@/api/hozoor";
export default {
  data() {
    return {
      gheibats: [],
      visibleGheibat: null,
      visibleCourse: null,
      courseHeaders: [
        {
          text: "تاريخ",
          value: "D_Date",
          width: "20%",
        },
        {
          text: "نمره/حضور",
          value: "markNoe",
          width: "20%",
        },
        { text: "توضيحات", value: "Comment", width: "60%" },
      ],
      headerProps: {
        sortByText: "مرتب سازی بر اساس",
      },
    };
  },
  created() {
    this.getGheibat();
    // window.addEventListener("scroll", this.handleScroll);
  },

  destroyed() {
    // window.removeEventListener("scroll", this.handleScroll);
  },
  computed: {
    tableText() {
      return this.$store.getters.tableText;
    },
    isMobile() {
      return this.$store.getters.isMobile;
    },
  },

  methods: {
    getGheibat() {
      getGheibat()
        .then((response) => {
          const data = response.data;
          this.gheibats = data;
          if (this.gheibats.length > 0) {
            this.visibleGheibat = 0;
            this.visibleCourse = Object.keys(this.gheibats[0].courses)[0];
          }
          this.$store.commit("SET_TABLE_TEXT", false);
        })
        .catch((error) => {
          this.$store.commit(
            "SET_SNACKBAR_TEXT",
            "خطایی به وجود آمده است لطفا مجددا تلاش کنید."
          );
        });
    },
    handleScroll() {
      var elements = document.querySelectorAll(".scrollHandler");
      for (var i = 0; i < elements.length; i++) {
        var element = elements[i];

        var position = element.getBoundingClientRect();

        // checking whether fully visible
        if (position.bottom >= 260) {
          var elId = element.id.split("_");
          this.visibleGheibat = parseInt(elId[0]);
          this.visibleCourse = elId[1];

          break;
        }
      }
    },
  },
};
</script>
<style scoped>
.fixedPosition {
  height: 160px;
  top: 60px;
}
</style>
